import { useEffect, useState } from "react";
import { useBreakpointValue } from "@chakra-ui/react";

const isUserAgentMobile = (): boolean => {
  if (typeof navigator === "undefined") return false;
  return /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
};

const useIsMobile = () => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const breakpointValue = useBreakpointValue({ base: true, md: false });
  const uaMobile = isUserAgentMobile();

  if (!isClient) return uaMobile;

  return breakpointValue || uaMobile;
};

export default useIsMobile;
